// Telemetry hooks here accept either a React ref or a raw DOM node.
//
// A ref is fine for a panel whose lifetime matches the component's — the ref is
// populated before effects run and torn down with it. It is NOT fine for a panel
// that is swapped while the component stays mounted (DESC ⇄ COSMO): the ref's
// identity never changes, so an effect keyed on it never re-runs and stays bound
// to the removed element. Those call sites pass the node itself via a callback
// ref, which does change identity and does re-run the effect.
export const resolveNode = (target) =>
  target && typeof target === 'object' && 'current' in target ? target.current : target
